import request from '@/utils/request'

// 获取用户列表
export function getUser(data) {
  return request({
    url: '/user/selectUser',
    method: 'post',
    data
  })
}
// 添加用户
export function addUser(data) {
  return request({
    url: '/login/register',
    method: 'post',
    data
  })
}
// 编辑用户
export function editUser(data) {
  return request({
    url: '/user/updateUser',
    method: 'post',
    data
  })
}
// 删除用户
export function delUser(id) {
  return request({
    url: `/user/delUser?id=${id}`,
    method: 'get'
  })
}
// 获取用户详情
export function getUserInfo(id) {
  return request({
    url: `/user/selectUserById/${id}`,
    method: 'post'
  })
}

// 获取用户详情
export function getMyUserInfo() {
  return request({
    url: '/user/selectUsrByToken',
    method: 'get'
  })
}
// 获取角色列表
export function getRole() {
  return request({
    url: '/role/list',
    method: 'get'
  })
}
// 编辑用户角色
export function editRole(data) {
  return request({
    url: '/user/updateUserRole',
    method: 'post',
    data
  })
}
// 添加角色
export function addRole(data) {
  return request({
    url: '/role/save',
    method: 'post',
    data
  })
}

// 获取权限列表
export function getPermission(data) {
  return request({
    url: '/permissions/permissionsRolelist',
    method: 'post',
    data
  })
}
// 更新权限列表
export function updatePermission(data) {
  return request({
    url: '/role/updateRolePermissions',
    method: 'post',
    data
  })
}
// 删除权限列表
export function delPermission(data) {
  return request({
    url: '/role/delRolePermissions',
    method: 'post',
    data
  })
}
// 获取权限管理列表
export function getPermissionList() {
  return request({
    url: '/permissions/list',
    method: 'get'
  })
}
// 添加权限管理
export function addPermission(data) {
  return request({
    url: '/permissions/updateOrSave',
    method: 'post',
    data
  })
}
// 删除权限管理
export function delPermissionList(id) {
  return request({
    url: `/permissions/del/${id}`,
    method: 'get'
  })
}
